module.exports = __webpack_public_path__ + "img/regensburg_kassian_2016_ref.2b302813.jpg";